import SEO from "../common/SEO";
import HeaderOne from '../common/header/HeaderOne';
import BrandThree from '../elements/brand/BrandThree';
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import CounterUpFour from "../elements/counterup/CounterUpFour";
import TimelineTwo from "../elements/timeline/TimelineTwo";
import Separator from "../elements/separator/Separator";
import SlpitOne from '../elements/split/SlpitOne';
import ScrollAnimation from 'react-animate-on-scroll';
import CustomFooter from '../elements/CustomFooter/CustomFooter';

const AboutUs = () => {

	const teamMembers = [
		{
			name: "Santosh Singh",
			role: "Founder",
			image: process.env.PUBLIC_URL + "./santosh.jpg"
		},
		{
			name: "Pankaj upadhayay",
			role: "CEO",
			image: process.env.PUBLIC_URL + "./pankaj.jpg"
		},
		{
			name: "Lokesh Mahaur",
			role: "Business Partner",
			image: process.env.PUBLIC_URL + "./lokesh.jpg"
		},
		{
			name: "Priyanshu Kuntal",
			role: "CTO",
			image: "./images/team/team-04.jpg"
		}
	];

	return (
		<>

			<SEO title="About Us" />
			<main className="page-wrapper">

				<HeaderOne btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent" />

				{/* Hero Section */}
				<div
					className="slider-area slider-style-1 height-850 bg_image"
					data-black-overlay="7"
					style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/bg/about-banner.jpg)` }}
				>
					<div className="container">
						<div className="row">
							<div className="col-lg-12">
								<div className="inner pt--80 text-center">
									<h3 className="rn-sub-badge">
										<span className="theme-gradient">This is</span>
									</h3>
									<h1 className="title display-one">Who We Are</h1>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* About Intro */}
				<div className="service-area rn-section-gapTop">
					<div className="container">
						<div className="row align-items-center">
							<div className="col-lg-6">
								<h3 className="title">
									Turning Bold Ideas Into Impactful, Innovative, And Meaningful Digital Journeys.
								</h3>
							</div>
							<div className="col-lg-6">
								<p>
									Since 2020, YGS Web Solutions Pvt. has been turning big ideas into reality.
									Based in India, we serve clients across China, the USA, Canada, and beyond
									offering strategy, design, development, and digital marketing to bring your vision to life.
								</p>
							</div>
						</div>
					</div>
				</div>

				{/* Clients */}
				<div className="rwt-brand-area pb--60 pt--30" style={{ marginTop: '6rem' }}>
					<div className="container">
						<SectionTitle
							textAlign="text-center"
							subtitle="Our Awesome Clients"
							title="Clients That Trust Us"
						/>
						<div className="row">
							<div className="col-lg-12 mt--10">
								<BrandThree brandStyle="brand-style-2" />
							</div>
						</div>
					</div>
				</div>

				<Separator />

				{/* Founder Quote */}
				<div className="rwt-split-area rn-section-gap">
					<div className="wrapper">
						<SlpitOne
							text1={'"We\'re all about building strong, long-term partnerships"'}
							text2={'YGS Web Solutions Pvt. Ltd. was founded with a simple mission: to shake up the online promotions scene in India with personalized top-notch services at prices that make sense.'}
							text3={'Santosh Singh — Founder, CEO'}
						/>
					</div>
				</div>

				{/* ================= OUR TEAM SECTION ================= */}
				<div className="rn-team-area rn-section-gap bg-color-dark">
					<div className="container">

						<SectionTitle
							textAlign="text-center"
							subtitle="Meet The Experts"
							title="Our Team"
							description="A passionate group of designers, developers, and strategists dedicated to your success."
						/>

						<div className="row mt--40">
							{teamMembers.map((member, index) => (
								<div key={index} className="col-lg-3 col-md-6 col-sm-6 col-12">
									<div className="team-card">
										<div className="team-img">
											<img src={member.image} alt={member.name} />
										</div>
										<div className="team-content">
											<h4 className="name">{member.name}</h4>
											<p className="designation">{member.role}</p>
										</div>
									</div>
								</div>
							))}
						</div>

					</div>
				</div>
				{/* ================= END TEAM SECTION ================= */}

				<Separator />

				{/* Middle Banner */}
				<div>
					<img src="./images/bg/middle-banner.jpg" width="100%" alt="Middle Banner" />
				</div>

				{/* Counter */}
				<div className="rwt-counterup-area pb--100" style={{ marginTop: '10rem', marginBottom: '-16rem' }}>
					<div className="container mt_dec--30">
						<CounterUpFour
							column="col-lg-3 col-md-6 col-sm-6 col-12"
							counterStyle="counter-style-4"
							textALign="text-center"
						/>
					</div>
				</div>

				{/* Timeline */}
				<div className="rwt-timeline-area rn-section-gap">
					<div className="container">
						<div className="row">
							<div className="col-lg-10 offset-lg-1 mt--50">
								<TimelineTwo
									TimelineData={[
										{ id: "1", title: "Business Upgrade", description: "Stay ahead with digital advancements." },
										{ id: "2", title: "Strategic Insights", description: "Expert advice to overcome challenges." },
										{ id: "3", title: "Competitive Solutions", description: "Cutting-edge practical solutions." },
										{ id: "4", title: "Innovative Vision", description: "Future-ready creative strategies." }
									]}
								/>
							</div>
						</div>
					</div>
				</div>

				<Separator />
				<CustomFooter />

			</main>
		</>
	)
}

export default AboutUs;
